import ActivityMessaging, {
  ActivityMessagingVariant,
} from '../../molecules/activity-messaging/ActivityMessaging';
import { FilePreviewVariant } from '../../atoms/file-preview/FilePreview.tsx';

export type ActivityMessagingInterkabSolutionsFieldProps = {
  jsonContent?: string;
  fileSrc?: string;
  fileName?: string;
  redirectionUrl?: string;
};

export const ActivityMessagingInterkabSolutionsField = ({
  jsonContent,
  fileSrc,
  fileName,
  redirectionUrl,
}: ActivityMessagingInterkabSolutionsFieldProps) => {
  const activity = {
    jsonContent: jsonContent,
  };

  return (
    <ActivityMessaging.Root variant={ActivityMessagingVariant.MEDIA}>
      {fileSrc && (
        <div className="relative">
          <ActivityMessaging.FilePreview
            fileSrc={fileSrc}
            variant={FilePreviewVariant.MEDIA}
            fileName={fileName}
          />

          {redirectionUrl && (
            <a
              href={redirectionUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="absolute inset-0"
            />
          )}
        </div>
      )}

      <ActivityMessaging.ExpandableContent enableResizeObserver>
        <ActivityMessaging.Content activity={activity} />
      </ActivityMessaging.ExpandableContent>
    </ActivityMessaging.Root>
  );
};
